import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import CardsGrid from "./CardsGrid";
const CardsGridPreview = () => {
    return (_jsx(CardsGrid, { dynamicList: [
            {
                title: "Titre 1",
                subtitle: "Sous titre 1",
                description: "Description 1",
            },
            {
                title: "Titre 2",
                subtitle: "Sous titre 2",
                description: "Description 2",
            },
            {
                title: "Titre 3",
                subtitle: "Sous titre 3",
                description: "Description 3",
            },
        ] }));
};
export default CardsGridPreview;
